import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import ReactStars from "react-rating-stars-component";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow, Navigation, Pagination } from 'swiper/modules';
import { Parallax } from 'react-parallax';

// Import Swiper styles
import 'swiper/css/bundle';

//image
import heroImage from '../images/txoko images/lugar/lugar5.webp';
import logo from '../images/whiteLogo.webp';

import section1Image from '../images/txoko images/lugar/lugar3.webp';

import section2Image1 from '../images/txoko images/lugar/txoko56.webp';
import section3Image2 from '../images/txoko images/platos/txoko36.webp';
import section4Image3 from '../images/txoko images/lugar/txoko59.webp';

import stars from '../images/stars.webp';

import instagramImage1 from '../images/txoko images/lugar/txoko55.webp';
import instagramImage2 from '../images/txoko images/lugar/lugar1.webp';
import instagramImage3 from '../images/txoko images/lugar/lugar5.webp';
import instagramImage4 from '../images/txoko images/lugar/txoko59.webp';

import gastronomyImage from '../images/txoko images/platos/txoko36.webp';

function HomePage() {
  const [hasViewedSection1, setHasViewedSection1] = useState(false);
  const [hasViewedSection2, setHasViewedSection2] = useState(false);
  const [hasViewedSection3, setHasViewedSection3] = useState(false);
  const [hasViewedSection4, setHasViewedSection4] = useState(false);
  const [hasViewedSection5, setHasViewedSection5] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  const { ref: refSection1, inView: inViewSection1 } = useInView({ threshold: 0.2 });
  const { ref: refSection2, inView: inViewSection2 } = useInView({ threshold: 0.1 });
  const { ref: refSection3, inView: inViewSection3 } = useInView({ threshold: 0.2 });
  const { ref: refSection4, inView: inViewSection4 } = useInView({ threshold: 0.1 });
  const { ref: refSection5, inView: inViewSection5 } = useInView({ threshold: 0.2 });

  const reviews = [
    {
      name: "Sofia Sanchez",
      role: "",
      rating: 5,
      comment:
        "Vinimos de casualidad a comer sin mesa reservada y nos dieron una mesa ideal en la terraza. Yo soy de Pamplona y este restaurante me ha hecho sentirme como en casa, la comida estaba deliciosa y hemos pasado un rato estupendo antes de marchar a trabajar. Nos atendió Eva, muy simpática",
    },
    {
      name: "Nuria",
      role: "Guia Local",
      rating: 5,
      comment:
        "Estaba todo riquísimo, tuvimos que reservar pero la espera mereció la pena. Amables, atentas, todo delicioso y apto para perritos. Un 10! Al postre no me dio tiempo ni de hacerle foto 🤤",
    },
    {
      name: "Mireia Sanchez",
      role: "Guia Local",
      rating: 5,
      comment: "Lugar bonito y acogedor, las camareras super amables y la comida riquísima, recomendable ir un día, reserva antes de ir por qué se llena a tope a la hora de comer.",
    },
    {
      name: "Hector Enriquez",
      role: "",
      rating: 5,
      comment: "Llegamos algo justitos, 4:05 y cerraban cocina a las 4:30. Atencion amable y rapida. La comida esta muy rica y las raciones son abundantes. Y para rematar, el tiramisu casero es una autentica delicia, recomiendo pedirlo a todos los amantes del tiramisu!",
    },
  ];

  useEffect(() => {
    if (inViewSection1 && !hasViewedSection1) {
      setHasViewedSection1(true);
    }
  }, [inViewSection1, hasViewedSection1]);

  useEffect(() => {
    if (inViewSection2 && !hasViewedSection2) {
      setHasViewedSection2(true);
    }
  }, [inViewSection2, hasViewedSection2]);

  useEffect(() => {
    if (inViewSection3 && !hasViewedSection3) {
      setHasViewedSection3(true);
    }
  }, [inViewSection3, hasViewedSection3]);

  useEffect(() => {
    if (inViewSection4 && !hasViewedSection4) {
      setHasViewedSection4(true);
    }
  }, [inViewSection4, hasViewedSection4]);

  useEffect(() => {
    if (inViewSection5 && !hasViewedSection5) {
      setHasViewedSection5(true);
    }
  }, [inViewSection5, hasViewedSection5]);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    setScrollY(window.scrollY);

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="font-montserrat bg-gray-50">

      {/* Hero Section */}
      <div className="relative w-full">
        <Parallax bgImage={heroImage} strength={100} bgImageStyle={{ objectFit: 'cover' }}>
          {/* Overlays */}
          <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent z-0 opacity-60"></div>
          <div className="absolute inset-0 bg-black opacity-30 z-0"></div>

          <section className="flex flex-col items-center justify-center relative h-[30vh] sm:h-[40vh] md:h-[100vh] lg:h-[100vh] xl:h-[104vh] mx-auto px-4 sm:px-6 md:px-8 lg:px-16 xl:px-24 overflow-hidden">
            <motion.div
              className="z-10 text-center text-white md:-mt-36"
              initial={{ opacity: 0, y: 100 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
            >
              <img src={logo} alt="Logo" className="h-24 sm:h-32 md:h-40 lg:h-48 xl:h-56 mx-auto" />

              {/* Mobile Reservation Button - only visible on mobile */}
              <div className="mt-3 md:hidden flex justify-center">
                <Link
                  to="/contact"
                  className="uppercase font-montserrat px-4 py-1.5 text-xs font-semibold text-white bg-transparent border border-white transform transition-all duration-300 hover:bg-white hover:text-sky-900 hover:scale-95"
                >
                  RESERVA AHORA!
                </Link>
              </div>
            </motion.div>
          </section>
        </Parallax>

        {/* Diagonal Divider */}
        <div className="absolute bottom-0 left-0 w-full overflow-hidden" style={{ marginBottom: "-1px" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 110"
            className="w-full"
          >
            <path
              fill="#f9fafb"
              fillOpacity="1"
              d="M0,30 L1440,0 L1440,110 L0,110 Z"
            />
          </svg>
        </div>
      </div>

      {/* About Section */}
      <section className="relative lg:-mt-24 lg:mb-32 bg-gray-50" ref={refSection1}>
        <motion.div
          className="relative flex flex-col items-center mx-auto lg:flex-row-reverse lg:max-w-5xl lg:mt-12 xl:max-w-6xl min-h-[400px] px-4 sm:px-8 lg:px-0"
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: hasViewedSection1 ? 1 : 0, y: hasViewedSection1 ? 0 : 100 }}
          transition={{ ease: 'easeOut', duration: 1 }}
        >
          {/* Image */}
          <motion.div
            className="w-full h-[300px] sm:h-[400px] lg:w-[550px] lg:h-auto flex-shrink-0"
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: scrollY * 0.03 }}
            transition={{ ease: 'easeOut', duration: 1 }}
          >
            <img
              className="rounded-2xl h-full w-full object-cover"
              src={section1Image}
              alt="Winding mountain road"
            />
          </motion.div>

          {/* Text Container */}
          <motion.div
            className="relative bg-white z-10 shadow-lg rounded-lg mt-8 lg:absolute lg:top-0 lg:mt-20 lg:w-3/5 lg:left-2 w-full"
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: scrollY * -0.03 }}
            transition={{ ease: 'easeOut', duration: 1 }}
          >
            <div className="flex flex-col mt-8 sm:mt-14 mb-8 px-6 sm:px-8 md:px-14">
              <h2 className="uppercase text-gray-800 text-[36px] sm:text-[48px] lg:text-[68px] text-center font-barlow font-bold leading-none">
                Descubre <span className="text-sky-900">Nuestra Carta</span>
              </h2>
              <p className="font-montserrat font-medium text-[14px] sm:text-[16px] lg:text-[18px] mt-4 text-center text-gray-600">
                Te invitamos a explorar un mundo de sabores en Txoko.<br /><br />
                Directamente del mar a tu plato, ofrecemos una amplia variedad de platos frescos y exquisitos,
                preparados con la pasión y la tradición de la cocina Menorquina.
              </p>
            </div>
            <div className="flex justify-center mb-10">
              <Link
                to="/menu"
                className="uppercase font-barlow px-5 sm:px-7 py-[5.5px] text-sm sm:text-md font-semibold text-sky-900 bg-transparent border-[2px] sm:border-[2.5px] border-sky-900 shadow-md transform transition-all duration-200 hover:text-white hover:scale-95 active:scale-110 focus:outline-none focus:ring-2 focus:ring-sky-900 hover:bg-sky-900 focus:ring-opacity-75"
              >
                La Carta
              </Link>
            </div>
          </motion.div>
        </motion.div>
      </section>

      {/* Call to action Menu and Gastronomy */}
      <section className="py-16 mb-16 bg-gray-50" ref={refSection2}>
        <div className="container mx-auto px-4 md:px-8 lg:px-16">
          <div className="flex flex-col lg:flex-row justify-center items-center gap-1">
            {/* Contenedor izquierdo */}
            <motion.div
              className="relative w-full max-w-2xl h-72 overflow-hidden rounded-md shadow-lg"
              style={{ backgroundImage: `url(${section2Image1})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
              initial={{ opacity: 0, x: -100 }}
              animate={hasViewedSection2 ? { opacity: 1, x: 0 } : { opacity: 0, x: -100 }}
              transition={{ duration: 1 }}
            >
              <div className="absolute inset-0 bg-black opacity-40 z-0"></div>
              <div className="absolute inset-0 flex flex-col justify-center items-center text-white p-4">
                <div className="text-[40px] md:text-[80px] font-barlow font-bold">MENÚ</div>
                <Link
                  to="/menu"
                  className="uppercase font-ubuntu px-7 py-[5.5px] text-[14px] md:text-[16px] font-semibold text-white bg-transparent border-[2.5px] border-white shadow-md transform transition-all duration-300 hover:bg-transparent hover:text-white hover:scale-90 active:scale-110 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-75"
                >
                  MenÚ
                </Link>
              </div>
            </motion.div>

            {/* Contenedor derecho */}
            <motion.div
              className="relative w-full max-w-2xl h-72 overflow-hidden rounded-md shadow-lg"
              style={{ backgroundImage: `url(${section3Image2})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
              initial={{ opacity: 0, x: -100 }}
              animate={hasViewedSection2 ? { opacity: 1, x: 0 } : { opacity: 0, x: -100 }}
              transition={{ duration: 1, delay: 0.2 }}
            >
              <div className="absolute inset-0 bg-black opacity-40 z-0"></div>
              <div className="absolute inset-0 flex flex-col justify-center items-center text-white p-4">
                <div className="text-[40px] md:text-[80px] font-barlow font-bold">GASTRONOMÍA</div>
                <Link
                  to="/gastronomy"
                  className="uppercase font-montserrat px-7 py-[5.5px] text-[14px] md:text-[16px] font-semibold text-white bg-transparent border-[2.5px] border-white shadow-md transform transition-all duration-300 hover:bg-transparent hover:text-white hover:scale-90 active:scale-110 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-75"
                >
                  GASTRONOMÍA
                </Link>
              </div>
            </motion.div>
          </div>

          {/* Contenedor adicional debajo */}
          <div className="mt-1 flex justify-center">
            <motion.div
              className="relative w-full lg:max-w-7xl max-w-2xl h-72 overflow-hidden rounded-md shadow-lg"
              style={{ backgroundImage: `url(${section4Image3})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
              initial={{ opacity: 0, x: -100 }}
              animate={hasViewedSection2 ? { opacity: 1, x: 0 } : { opacity: 0, x: -100 }}
              transition={{ duration: 1, delay: 0.4 }}
            >
              <div className="absolute inset-0 bg-black opacity-40 z-0"></div>
              <div className="absolute inset-0 flex flex-col justify-center items-center text-white p-4">
                <div className="text-[40px] md:text-[80px] font-barlow font-bold">CONTACTO</div>
                <Link
                  to="/contact"
                  className="uppercase font-montserrat px-7 py-[5.5px] text-[14px] md:text-[16px] font-semibold text-white bg-transparent border-[2.5px] border-white shadow-md transform transition-all duration-300 hover:bg-transparent hover:text-white hover:scale-90 active:scale-110 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-75"
                >
                  Contacto
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* What Our Clients Say Section */}
      <section className="mb-20 bg-gray-50" ref={refSection3}>
        <motion.div
          className="max-w-7xl mx-auto px-6 md:px-12 xl:px-6 text-center select-none"
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: hasViewedSection3 ? 1 : 0, y: hasViewedSection3 ? 0 : 100 }}
          transition={{ ease: 'easeOut', duration: 1 }}
        >
          <div className="mb-12 space-y-4">
            <img
              className="mx-auto -mb-12 h-28 w-auto rounded-lg"
              src={stars}
              alt="Google Logo"
            />
            <h2 className="font-barlow text-[30px] md:text-[60px] font-bold text-gray-800 ">
              ¿QUÉ OPINAN NUESTROS CLIENTES?
            </h2>
            <p className="font-ubuntu text-sm text-gray-500">
              Lee las experiencias de nuestros clientes.
            </p>
            <div className="font-montserrat text-gray-700 mt-4">
              <span className="text-yellow-500 text-lg font-bold">4.4 ⭐</span> (+1.000 reseñas)
            </div>
          </div>

          {/* Carrusel de Reseñas con Swiper */}
          <Swiper
            modules={[Navigation, Pagination, Autoplay, EffectCoverflow]}
            effect='coverflow'
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: false,
            }}
            grabCursor={true}
            loop={true}
            pagination={{ clickable: true, dynamicBullets: true, dynamicMainBullets: 1 }}
            autoplay={{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }}
            className="mySwiper pb-12"
            breakpoints={{
              // cuando el ancho de la ventana es >= 320px
              320: {
                slidesPerView: 1,
                spaceBetween: 20
              },
              // cuando el ancho de la ventana es >= 768px
              768: {
                slidesPerView: 1,
                spaceBetween: 20
              },
              // cuando el ancho de la ventana es >= 1024px
              1024: {
                slidesPerView: 3,
                spaceBetween: 20
              }
            }}
          >
            {reviews.map((review, index) => (
              <SwiperSlide
                key={index}
                className='flex justify-center'>
                <div className="bg-white p-8 mt-6 mb-6 ml-4 mr-4 rounded-md shadow-lg h-[250px] w-[400px] flex flex-col justify-center">
                  <div>
                    <div className="flex items-center mb-4 gap-4">
                      <div className="w-12 h-12 rounded-full bg-orange-500 flex items-center justify-center text-white font-bold uppercase font-sans">
                        {review.name.split(' ').map((n) => n[0]).join('')}
                      </div>
                      <div>
                        <h6 className="text-lg font-medium text-gray-700 text-left">
                          {review.name}
                        </h6>
                        <p className="text-sm text-gray-500">{review.role}</p>
                      </div>
                    </div>

                    {/* Componente de estrellas usando react-rating-stars-component */}
                    <div className="mb-4">
                      <ReactStars
                        count={5}
                        value={review.rating}
                        isHalf={true}
                        size={24}
                        activeColor="#ffd700"
                        emptyColor="#d8d8d7"
                        edit={false}
                      />
                    </div>

                    <p className="font-montserrat text-left text-gray-600 line-clamp-5 text-[11px]">{review.comment}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>

        <div className="flex justify-center mt-10">
          <a
            href="https://www.google.com/search?sca_esv=c9803a166ab8e7a0&tbm=lcl&sxsrf=ADLYWILcf8GjLoCAA1LIvHPX2Q-29yu5Sw:1736707824396&q=El%20Txoko%20Rese%C3%B1as&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxI2MzczsjQ2NrCwNDA3tzQ1t7Q03sDI-IpR0DVHIaQiPztfISi1OPXwxsTiRayYYgCXjUedQgAAAA&rldimm=6762933089077957993&hl=es-ES&sa=X&ved=0CAcQ5foLahcKEwiY4KDp7PCKAxUAAAAAHQAAAAAQBg#lkt=LocalPoiReviews&arid=ChdDSUhNMG9nS0VJQ0FnSURiajR2N3VBRRAB"
            target="_blank"
            rel="noopener noreferrer"
            className="uppercase font-barlow px-7 py-[5.5px] text-sm font-semibold text-blue-500 bg-transparent border-[2.5px] border-blue-500 shadow-md transform transition-all duration-200 hover:scale-95 active:scale-110 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:ring-opacity-75"
          >
            Ver más reseñas
          </a>
        </div>
      </section>

      {/* Instagram Posts Section */}
      <section className="mb-20 py-8 bg-gray-50" ref={refSection4}>
        <motion.div
          className="container mx-auto px-6 md:px-12 xl:px-6 text-center select-none"
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: hasViewedSection4 ? 1 : 0, y: hasViewedSection4 ? 0 : 100 }}
          transition={{ ease: 'easeOut', duration: 1 }}
        >
          <div className="mb-12 space-y-4">
            <h2 className="font-barlow text-[40px] sm:text-[50px] md:text-[60px] font-bold text-gray-800">
              SÍGUENOS EN INSTAGRAM
            </h2>
            <p className="font-montserrat text-gray-500">
              Mira nuestras últimas publicaciones.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-1 max-w-lg mx-auto">
            {/* Imagen 1 */}
            <motion.div
              className="relative rounded-md shadow-lg overflow-hidden"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <a href="https://www.instagram.com/txokomenorca/" target="_blank" rel="noopener noreferrer">
                <img
                  src={instagramImage1}
                  alt="Instagram post 1"
                  className="w-full aspect-square object-cover"
                />
                <div className="absolute inset-0 bg-black opacity-10 hover:opacity-0 transition-opacity duration-300"></div>
              </a>
            </motion.div>

            {/* Imagen 2 */}
            <motion.div
              className="relative rounded-md shadow-lg overflow-hidden"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
            >
              <a href="https://www.instagram.com/txokomenorca/" target="_blank" rel="noopener noreferrer">
                <img
                  src={instagramImage2}
                  alt="Instagram post 2"
                  className="w-full aspect-square object-cover"
                />
                <div className="absolute inset-0 bg-black opacity-10 hover:opacity-0 transition-opacity duration-300"></div>
              </a>
            </motion.div>

            {/* Imagen 3 */}
            <motion.div
              className="relative rounded-md shadow-lg overflow-hidden"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <a href="https://www.instagram.com/txokomenorca/" target="_blank" rel="noopener noreferrer">
                <img
                  src={instagramImage3}
                  alt="Instagram post 3"
                  className="w-full aspect-square object-cover"
                />
                <div className="absolute inset-0 bg-black opacity-10 hover:opacity-0 transition-opacity duration-300"></div>
              </a>
            </motion.div>

            {/* Imagen 4 */}
            <motion.div
              className="relative rounded-md shadow-lg overflow-hidden"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
            >
              <a href="https://www.instagram.com/txokomenorca/" target="_blank" rel="noopener noreferrer">
                <img
                  src={instagramImage4}
                  alt="Instagram post 4"
                  className="w-full aspect-square object-cover"
                />
                <div className="absolute inset-0 bg-black opacity-10 hover:opacity-0 transition-opacity duration-300"></div>
              </a>
            </motion.div>
          </div>
        </motion.div>
        <div className="mt-8 text-center">
          <a
            href="https://www.instagram.com/txokomenorca/"
            target="_blank"
            rel="noopener noreferrer"
            className="uppercase font-montserrat px-7 py-[5.5px] text-md font-semibold text-pink-600 bg-transparent border-[2.5px] border-pink-600 shadow-md transform transition-all duration-200 hover:bg-blue-00 hover:text-white hover:scale-95 active:scale-110 focus:outline-none focus:ring-2 focus:ring-pink-600 hover:bg-pink-600 focus:ring-opacity-75"
          >
            Visita nuestro Instagram
          </a>
        </div>
      </section>

      {/* Gastronomy Section */}
      <section className="relative mb-12 lg:mb-36 -mt-12 lg:mt-12 bg-gray-50" ref={refSection5}>
        <motion.div
          className="relative flex flex-col items-center mx-auto lg:flex-row lg:max-w-5xl lg:mt-12 xl:max-w-6xl min-h-[400px] px-4 sm:px-8 lg:px-0"
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: hasViewedSection5 ? 1 : 0, y: hasViewedSection5 ? 0 : 100 }}
          transition={{ ease: 'easeOut', duration: 1 }}
        >
          {/* Imagen */}
          <motion.div
            className="w-full h-[300px] sm:h-[400px] lg:w-[550px] lg:h-auto flex-shrink-0"
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: (scrollY - 3000) * 0.04 }}
            transition={{ ease: 'easeOut', duration: 1 }}
          >
            <img
              className="rounded-2xl h-full w-full object-cover"
              src={gastronomyImage}
              alt="Winding mountain road"
            />
          </motion.div>

          {/* Contenedor del texto */}
          <motion.div
            className="relative bg-white z-10 shadow-lg rounded-lg mt-8 lg:absolute lg:top-0 lg:mt-20 lg:w-3/5 lg:right-2 w-full"
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: (scrollY - 3000) * -0.04 }}
            transition={{ ease: 'easeOut', duration: 1 }}
          >
            <div className="flex flex-col mt-8 sm:mt-14 mb-8 px-6 sm:px-8 md:px-14">
              <h2 className="uppercase text-gray-800 text-[36px] sm:text-[48px] lg:text-[68px] text-center font-barlow font-bold leading-none">
                Nuestra <span className="text-sky-900">Gastronomía</span>
              </h2>
              <p className="font-montserrat font-medium text-[14px] sm:text-[16px] lg:text-[18px] mt-4 text-center text-gray-600">
                En Txoko, cada plato es una obra de arte. <br /><br />
                Combinamos los ingredientes más frescos de Menorca con técnicas
                culinarias innovadoras para ofrecerte una experiencia gastronómica
                inolvidable. Descubre la esencia del Mediterráneo en cada bocado.
              </p>
            </div>
            <div className="flex justify-center mb-10">
              <Link
                to="/gastronomy"
                className="uppercase font-barlow px-5 sm:px-7 py-[5.5px] text-sm sm:text-md font-bold text-sky-900 bg-transparent border-[2px] sm:border-[2.5px] border-sky-900 shadow-md transform transition-all duration-200 hover:text-white hover:scale-95 active:scale-110 focus:outline-none focus:ring-2 focus:ring-sky-900 hover:bg-sky-900 focus:ring-opacity-75"
              >
                Gastronomia
              </Link>
            </div>
          </motion.div>
        </motion.div>
      </section>

      {/* Reserva Mesa Call to action */}
      <Parallax
        bgImage={heroImage}
        strength={100}
        bgImageStyle={{ objectFit: 'cover' }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent z-0 opacity-75"></div>
        <div className="absolute inset-0 bg-black opacity-40 z-0"></div>
        <section className="py-24 sm:py-32 md:py-44 relative z-10">
          <div className="container mx-auto text-center px-4 py-12 lg:mb-24">
            <h2 className="text-white font-barlow uppercase text-[50px] sm:text-[70px] md:text-[100px] font-bold -mb-2 leading-tight">
              Reserva tu mesa ahora
            </h2>
            <p className="uppercase font-montserrat text-white text-[16px] sm:text-[18px] md:text-[20px] mt-2 sm:mt-4">
              Ven a vernos y disfruta de la mejor comida de mar en Menorca
            </p>
            <div className="flex justify-center mt-8 sm:mt-12">
              <Link
                className="custom-link uppercase font-montserrat px-5 sm:px-7 py-2 sm:py-[6.5px] text-sm sm:text-lg font-semibold text-white bg-transparent border-[2px] sm:border-[2.5px] border-white shadow-md transform transition-all ease-in-out duration-300 hover:scale-95 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-75"
                to="/contact"
              >
                Reserva ahora!
              </Link>
            </div>
          </div>
        </section>

        {/* Línea diagonal en la parte superior */}
        <div className="absolute top-0 left-0 w-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 110"
            className="w-full"
          >
            <path
              fill="#f9fafb"
              fillOpacity="1"
              d="M0,60 L1440,0 L1440,0 L0,0 Z"
            />
          </svg>
        </div>
      </Parallax>

      {/* División Linea Diagonal */}
      <div className="relative bg-gray-50">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 110"
          className="absolute bottom-0 left-0 w-full"
        >
          <path
            fill="#f9fafb"
            fillOpacity="1"
            d="M0,60 L1440,0 L1440,1100 L0,1100 Z"
          />
        </svg>
      </div>

    </div>
  );
}

export default HomePage;